import React, { Component } from 'react';
import axios from 'axios';
import { withTranslation } from 'react-i18next';

class Question1 extends Component {
	constructor(props) {
		super(props);
		this.state = {
      answer: '',
		};

    this.selectSatisfaction = this.selectSatisfaction.bind(this);
		this.closeFeedback = this.closeFeedback.bind(this);
		this.closeFeedbackForNow = this.closeFeedbackForNow.bind(this);
	}

	componentDidMount() {
		// scroll back to top page
		window.scrollTo(0, 0);

	}

	render() {

    return(
      <div className="feedback-question">
        <h2>{this.props.t('Question1-Hoe tevreden ben je over Framefit')}</h2>
        <p>{this.props.t('Question1-Bedankt')}</p>
        <p>{this.props.t('Question1-Wij streven constant naar')}.</p>
        <div className="satisfaction-container row">
          <div className="col">
            <img id="face1" className="face img-responsive" src="/img/satisfaction/face1.png" alt="Zeer ontevreden" onClick={() => {this.selectSatisfaction(1)}}/>
          </div>
          <div className="col">
            <img id="face2" className="face img-responsive" src="/img/satisfaction/face2.png" alt="Zeer ontevreden" onClick={() => {this.selectSatisfaction(2)}}/>
          </div>
          <div className="col">
            <img id="face3" className="face img-responsive" src="/img/satisfaction/face3.png" alt="Zeer ontevreden" onClick={() => {this.selectSatisfaction(3)}}/>
          </div>
          <div className="col">
            <img id="face4" className="face img-responsive" src="/img/satisfaction/face4.png" alt="Zeer ontevreden" onClick={() => {this.selectSatisfaction(4)}}/>
          </div>
          <div className="col">
            <img id="face5" className="face img-responsive" src="/img/satisfaction/face5.png" alt="Zeer ontevreden" onClick={() => {this.selectSatisfaction(5)}}/>
          </div>
        </div>
        <div className="button-container row">
          <div className="col">
            <button className="btn btn-default" onClick={() => {this.closeFeedback()}}>{this.props.t('Question1-Niet meer vragen')}</button>
          </div>
          <div className="col">
            <button className="btn btn-default col" onClick={() => {this.closeFeedbackForNow()}}>{this.props.t('Question1-Vraag later opnieuw')}</button>
          </div>
        </div>
      </div>
    )


	}

  selectSatisfaction = function (num) {
    let url = "/feedback/satisfaction-rate";
    let sessionId = localStorage.getItem('sessionId');
    let data = {
			'session_id' : sessionId,
      'rate' : num
    };
    axios.post(url, data).then(response => {
      if (num > 3) {
        this.props.nextQuestion(1);
      } else {
        this.props.nextQuestion(4);
      }

		}).catch(response => {
      console.log('error');
		})
  }

	closeFeedback = function () {
		this.props.nextQuestion(6);
	}

	closeFeedbackForNow = function () {
		this.props.nextQuestion(7);
	}


}

export default withTranslation('result')(Question1);
